<div class="auth-modal">
  @if (dismissible) {
    <button
      type="button"
      class="close-button"
      aria-label="Close login"
      (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  }

  @if (step === 'auth') {
    <img
      class="back-button"
      src="assets/img/white-back-arrow.svg"
      (click)="step = 'intro'" />
  } @else if (step === 'reset-password') {
    <img
      class="back-button"
      src="assets/img/white-back-arrow.svg"
      (click)="goBackToSignIn()" />
  }

  <!-- INTRO STEP -->
  @if (step === 'intro') {
    <div class="intro-content">
      <div class="auth-header">
        <img src="assets/img/tidy-logo.svg" alt="TIDY for Pros" class="logo" />
        <tidy-text [title]="'TIDY.com for Pros'"></tidy-text>
      </div>

      <tidy-text [body]="'Earn more with less time on admin work.'" class="intro-subtitle"></tidy-text>

      <div class="feature-cards">
        <div class="feature-card">
          <div class="feature-icon-wrapper">
            <tidy-image [src]="'assets/svg/people.svg'" class="feature-icon"></tidy-image>
          </div>
          <div class="feature-text">
            <tidy-text [header]="'Get New Clients'"></tidy-text>
            <tidy-text [body]="'Great pros earn up to $200/day more.*'"></tidy-text>
          </div>
        </div>

        <div class="feature-card">
          <div class="feature-icon-wrapper">
            <tidy-image [src]="'assets/svg/calendar.svg'" class="feature-icon"></tidy-image>
          </div>
          <div class="feature-text">
            <tidy-text [header]="'Control Everything'"></tidy-text>
            <tidy-text [body]="'Pick your schedule, area, & services.'"></tidy-text>
          </div>
        </div>

        <div class="feature-card">
          <div class="feature-icon-wrapper">
            <tidy-image [src]="'assets/svg/cash.svg'" class="feature-icon"></tidy-image>
          </div>
          <div class="feature-text">
            <tidy-text [header]="'Save Time & Money'"></tidy-text>
            <tidy-text [body]="'Let clients book & pay online.'"></tidy-text>
          </div>
        </div>

        <div class="feature-card">
          <div class="feature-icon-wrapper">
            <tidy-image [src]="'assets/svg/timer.svg'" class="feature-icon"></tidy-image>
          </div>
          <div class="feature-text">
            <tidy-text [header]="'Fast, Easy, & Free'"></tidy-text>
            <tidy-text [body]="'Get new clients in as little as 2 days.'"></tidy-text>
          </div>
        </div>
      </div>

      <tidy-row>
        <tidy-button
          [text]="'Create Account'"
          [action]="goToSignUp.bind(this)"
          class="primary full-width">
        </tidy-button>
      </tidy-row>

      <tidy-row>
        <tidy-button
          [text]="'Log In'"
          [action]="goToSignIn.bind(this)"
          class="secondary full-width">
        </tidy-button>
      </tidy-row>

      <div class="intro-footer">
        <tidy-text
          [helper]="'By signing up you agree to the '">
        </tidy-text>
        <tidy-text
          [actionBody]="'Service Provider Customer Agreement.'"
          (action)="openAgreement()">
        </tidy-text>
      </div>
    </div>
  }

  <!-- AUTH STEP -->
  @if (step === 'auth') {
    <div class="auth-content">
      <div class="auth-header">
        <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
      </div>

      <div class="auth-tabs">
        <button
          class="tab"
          [class.active]="mode === 'signin'"
          (click)="switchMode('signin')">
          Sign In
        </button>
        <button
          class="tab"
          [class.active]="mode === 'signup'"
          (click)="switchMode('signup')">
          Sign Up
        </button>
      </div>

      <!-- Social login commented out for now
      <div class="social-buttons">
        <button class="social-button google" (click)="signInWithGoogle()">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span>Google</span>
        </button>
        <button class="social-button apple" (click)="signInWithApple()">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          <span>Apple</span>
        </button>
      </div>

      <div class="divider">
        <span>or</span>
      </div>
      -->

      @if (mode === 'signin') {
        <form [formGroup]="signInForm" class="auth-form">
          <tidy-input
            formControlName="email"
            [form]="signInForm.controls.email"
            [label]="'Email'"
            type="email"
            [errorMessage]="'Please enter a valid email.'"
            [submitted]="submitted"
            [icon]="'assets/svg/mail.svg'">
          </tidy-input>
          <tidy-input
            formControlName="password"
            [form]="signInForm.controls.password"
            [label]="'Password'"
            type="password"
            [errorMessage]="'Password is required.'"
            [submitted]="submitted"
            [icon]="'assets/svg/lock-closed.svg'">
          </tidy-input>
          @if (errorMessage) {
            <tidy-error-message [text]="errorMessage"></tidy-error-message>
          }
          <tidy-row>
            <tidy-button
              [text]="'Sign In'"
              [action]="onSignIn.bind(this)"
              class="primary full-width">
            </tidy-button>
          </tidy-row>
          <div class="forgot-links">
            <tidy-text [actionBody]="'Forgot password?'" (action)="forgotPassword()"></tidy-text>
          </div>
        </form>
      }

      @if (mode === 'signup') {
        <form [formGroup]="signUpForm" class="auth-form">
          <div class="form-row">
            <tidy-input
              formControlName="firstName"
              [form]="signUpForm.controls.firstName"
              [label]="'First Name'"
              [errorMessage]="'Please enter your first name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'">
            </tidy-input>
            <tidy-input
              formControlName="lastName"
              [form]="signUpForm.controls.lastName"
              [label]="'Last Name'"
              [errorMessage]="'Please enter your last name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'">
            </tidy-input>
          </div>
          <tidy-input
            formControlName="email"
            [form]="signUpForm.controls.email"
            [label]="'Email'"
            type="email"
            [errorMessage]="'Please enter a valid email.'"
            [submitted]="submitted"
            [icon]="'assets/svg/mail.svg'">
          </tidy-input>
          <tidy-input
            formControlName="password"
            [form]="signUpForm.controls.password"
            [label]="'Password'"
            type="password"
            [errorMessage]="'Password must be at least 8 characters.'"
            [submitted]="submitted"
            [icon]="'assets/svg/lock-closed.svg'">
          </tidy-input>
          @if (errorMessage) {
            <tidy-error-message [text]="errorMessage"></tidy-error-message>
          }
          <tidy-row>
            <tidy-button
              [text]="'Create Account'"
              [action]="onSignUp.bind(this)"
              class="primary full-width">
            </tidy-button>
          </tidy-row>
          <tidy-row [align]="'center'">
            <tidy-text [helper]="'By creating an account, you agree to our'"></tidy-text><span>&nbsp;</span>
            <tidy-text [actionBody]="'Service Provider Agreement'" (action)="openAgreement()"></tidy-text>
          </tidy-row>
        </form>
      }
    </div>
  }

  <!-- RESET PASSWORD STEP -->
  @if (step === 'reset-password') {
    <div class="auth-content">
      <div class="auth-header">
        <img src="assets/img/tidy-logo.svg" alt="TIDY" class="logo" />
        <h1>Reset Password</h1>
        <p>Enter your email address and we'll send you instructions to reset your password</p>
      </div>

      <form [formGroup]="resetPasswordForm" class="auth-form">
        <tidy-input
          formControlName="email"
          [form]="resetPasswordForm.controls.email"
          [label]="'Email'"
          type="email"
          [errorMessage]="'Please enter a valid email.'"
          [submitted]="submitted"
          [icon]="'assets/svg/mail.svg'">
        </tidy-input>
        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage"></tidy-error-message>
        }
        @if (successMessage) {
          <div class="success-message">{{ successMessage }}</div>
        }
        <tidy-row>
          <tidy-button
            [text]="'Send Reset Instructions'"
            [action]="onResetPassword.bind(this)"
            [disabled]="isLoading"
            class="primary full-width">
          </tidy-button>
        </tidy-row>
      </form>
    </div>
  }
</div>
